export const PENDING = 'pending'
export const REPROVED = 'reproved'
export const APPROVED = 'approved'
export const DELETED_BY_REQUESTOR = 'deleted_by_requestor'